import React, { FunctionComponent, useEffect, useRef, useContext } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { PageAnimationFullScreen } from 'components/LayoutAnimations/PageAnimationFullScreen';
import { RecordingHeaderTags } from './components/RecordingHeaderTags';
import { RecordingWrapper } from './components/RecordingWrapper';
import { RecordingHeader } from './components/RecordingHeader';
import { RecordingContent } from './components/RecordingContent';
import { RecordingFooter } from './components/RecordingFooter';
import { setCurrentRecording } from 'features/recordings/recordingsSlice';
import { setAudioUrl } from 'features/audio/audioSlice';
import { useRecording } from 'features/recordings/recordingHooks';
import { Loader } from 'components/Loader';
import { useFetchRecording } from 'features/recordings/recordingHooks';
import { UserAgentContext } from 'features/user-agent/userAgent';
import { useNativeEvents } from 'hooks/useNativeEvents';

export const Recording: FunctionComponent = () => {
  const dispatch = useDispatch();
  const { id } = useParams();

  const recording = useRecording(id);

  const location = useLocation() as any;
  const minimiseUrl = (location.state && location.state.prevPath) || '/';
  const { isListenerAppWebview } = useContext(UserAgentContext);
  const { postMessage } = useNativeEvents();

  const isRecordingUrlSet = useRef<boolean>(false);

  useEffect(
    function listenerAppPostRecordingUrl() {
      if (isListenerAppWebview && recording && !isRecordingUrlSet.current) {
        isRecordingUrlSet.current = true;
        const audioUrl =
          process.env.REACT_APP_ENV_NAME === 'development'
            ? 'https://ilo-voices.cdn.prismic.io/ilo-voices/c336ed2f-9e7f-4303-a426-590a63fd8462_The+Future+of+Work+Podcast+-+Green+Jobs+%28French%29.mp3'
            : recording.url;
        postMessage({ audioUrl: audioUrl });
      }
    },
    [isListenerAppWebview, recording, postMessage]
  );

  useFetchRecording(id);

  useEffect(() => {
    if (id) {
      dispatch(setCurrentRecording(id));
    }
  }, [dispatch, id]);

  useEffect(() => {
    if (recording) {
      dispatch(setAudioUrl(recording.url));
    }
  }, [recording, dispatch]);

  if (!recording) {
    return <Loader fillComponent={true} />;
  }

  return (
    <PageAnimationFullScreen>
      <RecordingHeaderTags recording={recording} />
      <RecordingWrapper artworkKey={recording.artworkKey ?? ''}>
        <RecordingHeader minimiseUrl={minimiseUrl} />
        <RecordingContent recording={recording} />
        <RecordingFooter recording={recording} />
      </RecordingWrapper>
    </PageAnimationFullScreen>
  );
};
